import BarLoader from 'react-spinners/BarLoader';

// ==============================|| Loader ||============================== //

const Loader = () => (
  <div className="position-fixed top-0" style={{ zIndex: 9999 }}>
    <BarLoader color="#7678ed" width="100vw" height="5px" />
  </div>
);

export default Loader;
